import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper'; ////actualizacion nodejs
import Table from '@mui/material/Table'; //actualizacion nodejs
import TableBody from '@mui/material/TableBody'; //act nodejs
import TableCell from '@mui/material/TableCell'; //actualziacion nodejs
import TableContainer from '@mui/material/TableContainer'; //actualziacion nodejs
import TableHead from '@mui/material/TableHead'; //ACT NODEJS
import TablePagination from '@mui/material/TablePagination'; //actualziacion nodejs
import TableRow from '@mui/material/TableRow'; //actualziacion nodejs
import Ticket from '../../components/Ticket';
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from 'react-redux';
import { getTickets } from '../../components/API';
import CircularProgress from '@mui/material/CircularProgress'; //actualizacion node js

export default function StickyHeadTable() {
  const hasWindow = typeof window !== 'undefined';
  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }
  const [tickets, setTickets] = useState([]);
  const dispatch  = useDispatch();
  const [cargar, setCargar] = useState(false);
  const {syncs} =  useSelector((state)=>{ return state })
  //const [porActualizar, setPorActualizar] = useState(0);
  const columns = [
    { id: 'clave', label: 'Lista de tickets', numeric: true,minWidth: 200, aling: "center" },
  ];

  useEffect(() => {
    let data = syncs.tickets;
    data.sort(function(a,b){
      return b.num_ticket - a.num_ticket;
    });
    setTickets(data);
    //getFaltantes();
  }, [syncs,cargar]);

  useEffect(() => {
    let data = syncs.tickets;
    data.sort(function(a,b){
      return b.num_ticket - a.num_ticket;
    });
    setTickets(data);
    //getFaltantes();
  }, []);

  async function updateTickets(){
    console.log("buscando");
    let tickets = await getTickets(syncs.vendedor.numero_vendedor);
    dispatch({type:"TICKETS_FETCHING", payload: { tickets } })
    dispatch({type:"FETCHING_END"})
    setCargar(false)
  };

  const CustomPaper = styled(Paper)({
    width: '100%',
    maxHeight: getWindowDimensions().height -100,
  });

  const CustomTableContainer = styled(TableContainer)({
    maxHeight: getWindowDimensions().height - 200,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <CustomPaper>
      {cargar?
        <>
          <div style={{display: "flex", justifyContent:"center"}} >
            <CircularProgress color="primary" size={300}/><br/>
          </div>
          <div style={{display: "flex", justifyContent:"center"}} >
            <span style={{fontWeight: 'bold', fontSize: 20, alignSelf: "center"}}>Actualizando tickets</span>
          </div>
        </>:
        <>
          <CustomTableContainer>
            <div style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
              <Button mode="contained"  style={styles.botones} onClick={()=>{setCargar(true);updateTickets();}} >Actualizar tickets</Button>
            </div>
            <Table stickyHeader aria-label="sticky table" key="tabla tickets">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={"center"}
                      style={{ minWidth: column.minWidth, fontSize: 27 }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tickets.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                  const stableKey = row && row.id_ticket ? row.id_ticket : (row && row.num_ticket ? `${row.vendedor}_${row.num_ticket}` : `ticket__${index}`);
                  return (
                    <Ticket data={row} index={index} key={stableKey} />
                  );
                })}
              </TableBody>
            </Table>
          </CustomTableContainer>
          <TablePagination
            rowsPerPageOptions={[3]}
            component="div"
            count={tickets.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      }
    </CustomPaper>
  );
}

const styles = {
  botones:{
    //marginTop:'10px', 
    marginBottom:'10px',
    alignItems:"center", 
    width:"70%", 
    alignSelf:"center", 
    alignContent: "center",
    elevation:.5, 
    alignContent:"center",
    backgroundColor: '#3f51b5',
  },
};